module.exports = __webpack_public_path__ + "img/indexBanner.c1a869b0.jpg";